export { default } from './daily-prompt'
